//#region types
import { WintFormProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion

function WintForm(props: WintFormProps) {
  return (
    <form onSubmit={props.onSubmit} onReset={props.onReset}>
      <Grid container>{props.children}</Grid>
    </form>
  );
}

export default WintForm;
